import { render, staticRenderFns } from "./MarkdownDocument.vue?vue&type=template&id=1521a195&"
import script from "./MarkdownDocument.vue?vue&type=script&lang=js&"
export * from "./MarkdownDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports